import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';


class FormUserDetails extends Component {
    continue = e =>{
        e.preventDefault();
        this.props.nextStep();
    }

    render() { 
        const {values,handleChange}= this.props;
        return ( 
            <MuiThemeProvider>
                <React.Fragment>
                    <AppBar title="Enetr User Details"/>
                    <TextField
                       hintText="Enter Your First Name"
                       floatingLabelText="First Name"
                       onChange={handleChange('firstName')}
                       defaultValue={values.firstName}
                    />
                    <br/>
                    <TextField
                       hintText="Enter Your Last Name"
                       floatingLabelText="Last Name"
                       onChange={handleChange('lastName')}
                       defaultValue={values.lastName}
                    />
                    <br/>
                    <TextField
                       hintText="Enter Your Email"
                       floatingLabelText="Email"
                       onChange={handleChange('email')}
                       SdefaultValue={values.email}
                    />
                    <br/>
                    <RaisedButton
                        label="continue"
                        primary={true}
                        style={StyleSheet.button}
                        onClick={this.continue}
                    />
                </React.Fragment>
            </MuiThemeProvider>
         )
    }
}

const styles={
      button:{
          margin:15
      }
}
 
export default FormUserDetails;